<template>
  <div>
    <!-- 悬浮按钮 -->
    <ul id="menu" class="mfb-component--br mfb-zoomin" data-mfb-toggle="hover">
      <li class="mfb-component__wrap">
        <span class="mfb-component__button--main" :style="{ backgroundColor: color }">
          <i class="bi bi-list"></i>
        </span>
        <ul class="mfb-component__list">
          <li v-if="showLoginOut">
            <span :style="{ backgroundColor: color }" class="mfb-component__button--child" @click="loginOut()">
              {{ language == "cn" ? "退出登录" : "LoginOut" }}
            </span>
          </li>
          <li v-if="!showLoginOut">
            <span :style="{ backgroundColor: color }" class="mfb-component__button--child"
              @click="languageChange('cn')">简体中文</span>
          </li>

          <li v-if="!showLoginOut && config.setForm ? config.setForm.islang : false">
            <span :style="{ backgroundColor: color }" class="mfb-component__button--child" @click="languageChange('en')">
              English </span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import "../assets/js/mfb.js";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      color: (state) => state.color,
      config: (state) => state.config,
    }),
  },

  data() {
    return {
      islang: false,
      projectId: "",
      userId:this.$router.currentRoute.query.userId,
      language: sessionStorage.getItem("language") || "cn",
      showLoginOut: false,
      isMobile: this.$tool.isMobile(),
    };
  },
  created() {
    this.projectId = sessionStorage.getItem("projectId") || 0;
  },
  async mounted() {
    await this.getProjectBaseConfig();
    this.showLoginOut=this.userId?true:false;
  },
  methods: {

    loginOut() {
      this.$confirm(
        `${this.language == "cn" ? "确认退出登录？" : "Are you sure to log out?"
        }`,
        `${this.language == "cn" ? "提示" : "warning"}`,
        {
          confirmButtonText: `${this.language == "cn" ? "确认" : "determine"}`,
          cancelButtonText: `${this.language == "cn" ? "取消" : "cancellation"
            }`,
          type: "warning",
          customClass: "customClass",
        }
      )
        .then(() => {
          this.$tool.loginOut();
          this.$router.push({
            name: "login",
            query: {
              projectId: sessionStorage.getItem("projectId"),
            },
          });
        })
        .catch(() => { });
    },
    languageChange(e) {
      sessionStorage.setItem("language", e);
      let title = "";
      if (e == "cn") {
        title = JSON.parse(sessionStorage.getItem("config")).baseForm.cn_title;
      }
      if (e == "en") {
        title = JSON.parse(sessionStorage.getItem("config")).baseForm.en_title;
      }
      sessionStorage.setItem("title", title);
      //修改中英文title
      window.location.reload();
    },
    async getProjectBaseConfig() {
      let res = await this.$api.getprojectconfiginfo({ projectId: this.projectId, key: "basic" });
      if (res.code == 200 && res.data) {
        this.$store.commit("setConfig", JSON.parse(res.data.typevalue));

      }
    },
  },
};
</script>

<style scoped></style>
<style>
@media (max-width: 438px) {
  .customClass {
    width: 90% !important;
  }
}
</style>
